// extracted by mini-css-extract-plugin
export default {"chatBubble":"chat-bubble_chatBubble__htgPs","mediaBubble":"chat-bubble_mediaBubble__mrlVl","attachments":"chat-bubble_attachments__Ih-TS"};